// extracted by mini-css-extract-plugin
export default {"wrap":"vertical-double-graph_wrap__b1Hi1"};